import React from "react"
import { View } from "react-native"
import { cn } from "../styles/utils"
import { Button } from "./Button"
import type { ButtonProps } from "./Button"

interface FloatingActionButtonProps extends Omit<ButtonProps, "children"> {
  icon: React.ReactNode
  label?: string
}

export const FloatingActionButton: React.FC<FloatingActionButtonProps> = ({
  onPress,
  icon,
  label,
  variant = "primary",
  className = "",
  ...props
}) => {
  return (
    <Button
      onPress={onPress}
      variant={variant}
      className={cn(
        "absolute bottom-6 right-6 shadow-lg rounded-full",
        label ? "px-6 py-3" : "w-14 h-14 items-center justify-center",
        className,
      )}
      {...props}
    >
      {icon}
      {label && <View className="ml-2">{label}</View>}
    </Button>
  )
}
